import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useTheme,
    Button,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FormattedMessage } from 'react-intl';
import { Paragraph } from '../Paragraph';

function DeleteRecipientDialog({
    open,
    onClose,
    onDelete,
    deleting,
    recipient,
}: any) {
    const muiTheme = useTheme();
    const fullScreen = useMediaQuery(muiTheme.breakpoints.down('sm'), {
        // https://github.com/mui-org/material-ui/issues/21048
        noSsr: true,
    });
    const id = `delete-recipient`;

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={onClose}
            aria-labelledby={id}
        >
            <DialogTitle id={id}>
                <FormattedMessage
                    defaultMessage="Remove a recipient?"
                    description="Confirmation Title remove recipient"
                />
            </DialogTitle>
            <DialogContent>
                <Paragraph small>
                    <FormattedMessage
                        defaultMessage="Are you sure you want to remove {respondent}?"
                        description="Confirmation to remove recipient"
                        values={{
                            respondent: (
                                <strong>
                                    {recipient
                                        ? recipient.emailAddress ||
                                          recipient.phoneNumber
                                        : '-'}{' '}
                                </strong>
                            ),
                        }}
                    />
                </Paragraph>
                {/* todo - Add information about if the respondent has been invited, reminded, answered the survey, etc */}
            </DialogContent>
            <DialogActions>
                <Button
                    type="button"
                    variant="text"
                    onClick={onClose}
                    disabled={deleting}
                >
                    <FormattedMessage
                        defaultMessage="No, keep"
                        description="Do not remove recipient"
                    />
                </Button>
                <Button
                    type="button"
                    variant="contained"
                    onClick={onDelete}
                    autoFocus
                    disabled={deleting}
                >
                    <FormattedMessage
                        defaultMessage="Yes, delete"
                        description="Remove recipient"
                    />
                    {deleting ? '...' : ''}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteRecipientDialog;
